export default {
  TYPE_QUERY_EQUAL: 'eq',
  TYPE_QUERY_DISTINCT: 'ne',
  TYPE_QUERY_CONTAINS: 'contains',
  TYPE_QUERY_GREATER_THAN: 'ge',
  TYPE_QUERY_LESS_THAN: 'le',
  TYPE_QUERY_GREATER_THAN_STRICT: 'gt',
  TYPE_QUERY_LESS_THAN_STRICT: 'lt',
  TYPE_QUERY_SET_OF_IDS: 'in_id',
};
